<div class="modal-container">
  <h2 class="title">Purposeful Workbook</h2>
  <p class="description">
    Great news! You've already ordered your Purposeful Workbook. It should arrive within 3-5 weeks of your order date:
    {{ date }}.
  </p>
  <!-- Using prettier ignore comment here to keep the period aligned with the end of the sentence without a space -->
  <!-- prettier-ignore -->
  <p class="description">
    If you have any questions or need to make a change, please contact
    <a class="support-link" href="mailto:support@kumanu.com" target="_blank">support@kumanu.com</a>.
  </p>
  <button class="button button-pill button-reverse button-got-it" (click)="closeClicked.emit()">Got it</button>
</div>
